export function getSelectedRowIds(api, selectedId) {
	let selectedNodes = api.getSelectedNodes();

	let listId = [];
	_.forEach(selectedNodes, function (node) {
		listId.push(node.id);
	});

	if (listId.length == 0 && selectedId != null) {
		listId.push(selectedId);
	}

	return listId;
}
